function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_TRAINING = '/training';

export const PATH_APP_LINK = '/apps';
export const PATH_FRESHCUE = '/freshcue';
export const PATH_FRESHCUE_LINK = `${PATH_FRESHCUE}/:routes?`;
export const PATH_FRESHCUE_INVITE = `${PATH_FRESHCUE}/invite/:teamName`;
export const PATH_FRESHCUE_DONOR_INVITE = `${PATH_FRESHCUE}/donor-invite/:token`;
export const PATH_FRESHCUE_VERIFY_EMAIL = `${PATH_FRESHCUE}/verify-email/:verificationToken`;
export const PATH_SHARE_LINK = '/share';
export const PATH_PUBLIC_MAP = '/map';
export const PATH_PUBLIC_MAP_REGION = '/map/regions/:city';
export const PATH_INVITE_LINK = (teamName) => `/invite/${teamName}`;

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: {
    root: path(ROOTS_AUTH, '/register'),
    existingUserFound: path(ROOTS_AUTH, '/register/existing-user-found'),
    chooseOrganization: path(ROOTS_AUTH, '/register/choose-organization'),
    nonProfit: {
      aboutYou: path(ROOTS_AUTH, '/register/non-profit/about-you'),
      aboutBusiness: path(ROOTS_AUTH, '/register/non-profit/about-business'),
      addTeamMembers: path(ROOTS_AUTH, '/register/non-profit/add-team-members'),
    },
    business: {
      aboutYou: path(ROOTS_AUTH, '/register/business/about-you'),
      aboutBusiness: path(ROOTS_AUTH, '/register/business/about-business'),
      addTeamMembers: path(ROOTS_AUTH, '/register/business/add-team-members'),
    },
    joinTeam: {
      email: path(ROOTS_AUTH, '/register/join-team'),
      invites: path(ROOTS_AUTH, '/register/team-invites'),
      invitesFor: (email) =>
        path(ROOTS_AUTH, `/register/join-team/?email=${email}`),
      info: path(ROOTS_AUTH, '/register/about-you-join-team'),
    },
    pendingVerification: path(ROOTS_AUTH, `/register/pending-verification`),
  },
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  resetPasswordForEmail: (email) =>
    path(ROOTS_AUTH, `/reset-password/?email=${email}`),
  verifyEmail: path(ROOTS_AUTH, '/verify-email/:verificationToken'),
  kbHandoff: path(ROOTS_AUTH, '/kb-handoff'),
  mobileHandoff: path(ROOTS_AUTH, '/mobile-handoff'),
  impersonationHandoff: path(ROOTS_AUTH, '/impersonate'),
  onboardingVerify: path(ROOTS_AUTH, '/onboarding-verify/:token'),
};

export const PATH_PAGE = {
  page404: '/404',
  page500: '/500',
  unsubscribe: '/unsubscribe/:type/:userId/:teamId',
  unsubscribeAll: '/unsubscribe-all/:userId/:teamId',
  newsletterUnsubscribe: '/newsletter/unsubscribe/:token',
  newsletterPreferences: '/newsletter/preferences/:token',
  newsletterConfirm: '/newsletter/confirm/:token',
};

export const PATH_HOME = {
  dashboard: ROOTS_DASHBOARD,
};

export const PATH_TRAINING = {
  root: ROOTS_TRAINING,
  start: path(ROOTS_TRAINING, '/start'),
  lesson: path(ROOTS_TRAINING, '/lesson'),
  exam: path(ROOTS_TRAINING, '/exam'),
  docUpload: path(ROOTS_TRAINING, '/upload-documents'),
  examReview: path(ROOTS_TRAINING, '/results'),
  waiver: path(ROOTS_TRAINING, '/waiver'),
  complete: path(ROOTS_TRAINING, '/complete'),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  chatShortcut: (conversationSid) =>
    path(ROOTS_DASHBOARD, `/chat/${conversationSid}`),
  careitId: path(ROOTS_DASHBOARD, '/careit-id'),
  kb: path(ROOTS_DASHBOARD, '/kb'),
  kbArticle: (id = ':articleId') => path(ROOTS_DASHBOARD, `/kb/articles/${id}`),
  kbArticleEdit: (id = ':articleId') =>
    path(ROOTS_DASHBOARD, `/kb/articles/${id}/edit`),
  kbAdmin: path(ROOTS_DASHBOARD, '/kb/admin'),
  kbAdminArticle: (id = ':articleId') =>
    path(ROOTS_DASHBOARD, `/kb/admin/articles/${id}`),
  wiki: path(ROOTS_DASHBOARD, '/wiki'),
  wikiArticle: (id = ':articleId') =>
    path(ROOTS_DASHBOARD, `/wiki/articles/${id}`),
  wikiArticleEdit: (id = ':articleId') =>
    path(ROOTS_DASHBOARD, `/wiki/articles/${id}/edit`),
  wikiAdmin: path(ROOTS_DASHBOARD, '/wiki/admin'),
  wikiAdminArticle: (id = ':articleId') =>
    path(ROOTS_DASHBOARD, `/wiki/admin/articles/${id}`),
  impact: path(ROOTS_DASHBOARD, '/impact'),
  reverifyEmailRequest: path(ROOTS_DASHBOARD, '/reverify-email'),
  reverifyEmail: path(ROOTS_DASHBOARD, '/reverify-email/:verificationToken'),
  incompleteDonations: path(ROOTS_DASHBOARD, '/incomplete-donations'),
  allPlans: path(ROOTS_DASHBOARD, '/all-plans'),
  subscriptionComplete: path(ROOTS_DASHBOARD, '/subscription-complete'),
  rescues: path(ROOTS_DASHBOARD, '/rescues'),
  donations: path(ROOTS_DASHBOARD, '/donations'),
  reports: path(ROOTS_DASHBOARD, '/reports'),
  distributionReports: path(ROOTS_DASHBOARD, '/reports/distributions'),
  donationsReport: path(ROOTS_DASHBOARD, '/donations-report'),
  mydonations: path(ROOTS_DASHBOARD, '/my-donations'),
  drivers: path(ROOTS_DASHBOARD, '/drivers'),
  incomingRequests: path(ROOTS_DASHBOARD, '/incoming-requests'),
  myrescues: path(ROOTS_DASHBOARD, '/my-rescues'),
  incompleteRescues: path(ROOTS_DASHBOARD, '/incomplete-rescues'),
  business: path(ROOTS_DASHBOARD, '/business'),
  npo: path(ROOTS_DASHBOARD, '/npo'),
  vehicle: path(ROOTS_DASHBOARD, '/vehicle'),
  findDonations: path(ROOTS_DASHBOARD, '/find-donations'),
  findItems: {
    donations: path(ROOTS_DASHBOARD, '/find-items/donations'),
    marketplace: path(ROOTS_DASHBOARD, '/find-items/marketplace'),
  },
  viewDonation: (id) => path(ROOTS_DASHBOARD, `/donations/${id}`),
  viewPartialDonation: (donationId, rescueId) =>
    path(ROOTS_DASHBOARD, `/donations/${donationId}/${rescueId}`),
  marketplace: {
    myListings: path(ROOTS_DASHBOARD, '/marketplace/my-listings'),
    myOrders: path(ROOTS_DASHBOARD, '/marketplace/my-orders'),
    viewOrder: (id) => path(ROOTS_DASHBOARD, `/marketplace/orders/${id}`),
    messages: path(ROOTS_DASHBOARD, '/marketplace/messages'),
    incomingOrders: path(ROOTS_DASHBOARD, '/marketplace/incoming-orders'),
    createListing: path(ROOTS_DASHBOARD, '/marketplace/listings/create'),
    editListing: (id) =>
      path(ROOTS_DASHBOARD, `/marketplace/listings/${id}/edit`),
    viewListing: (id) => path(ROOTS_DASHBOARD, `/marketplace/listings/${id}`),
    checkout: (id) =>
      path(ROOTS_DASHBOARD, `/marketplace/listings/${id}/checkout`),
  },
  cancellationReport: path(ROOTS_DASHBOARD, '/cancellations'),
  viewFoodRun: (id) => path(ROOTS_DASHBOARD, `/food-run/view/${id}`),
  editDonationSingleInstance: (id) =>
    path(ROOTS_DASHBOARD, `/donation/edit/individual/${id}`),
  editRecurringDonation: (id) =>
    path(ROOTS_DASHBOARD, `/donation/edit/recurring/${id}`),
  editFoodRunSingleInstance: (id) =>
    path(ROOTS_DASHBOARD, `/food-run/edit/individual-run/${id}`),
  editRecurringFoodRun: (id) =>
    path(ROOTS_DASHBOARD, `/food-run/edit/recurring/${id}`),
  editOrg: (id) => path(ROOTS_DASHBOARD, `/org/edit/${id}`),
  viewOrg: (id) => path(ROOTS_DASHBOARD, `/org/${id}`),
  teams: path(ROOTS_DASHBOARD, '/users'),
  users: path(ROOTS_DASHBOARD, '/users'),
  viewTeamMember: (id) => path(ROOTS_DASHBOARD, `/team-member/${id}`),
  invitations: path(ROOTS_DASHBOARD, '/invitations'),
  trainingEditor: path(ROOTS_DASHBOARD, '/training-editor'),
  customizeEmail: path(ROOTS_DASHBOARD, '/customize-email'),
  agreements: path(ROOTS_DASHBOARD, '/agreements'),
  partnerships: path(ROOTS_DASHBOARD, '/partnerships'),
  agreement: (id) => path(ROOTS_DASHBOARD, `/agreement/${id}`),
  corporateOnboarding: {
    donorOnboarding: path(ROOTS_DASHBOARD, '/corp-onboarding/donor'),
    requests: path(ROOTS_DASHBOARD, '/corp-onboarding/requests'),
    request: (id = '', gatekeeperId = '') =>
      path(
        ROOTS_DASHBOARD,
        `/gatekeeper-onboarding/request/${id}/${gatekeeperId}`
      ),
    progress: (id, teamId) =>
      path(ROOTS_DASHBOARD, `/corp-onboarding/progress/${id}/${teamId}`),
    complete: {
      form: (id) =>
        path(ROOTS_DASHBOARD, `/corp-onboarding/complete/form/${id}`),
      agreement: (id) =>
        path(ROOTS_DASHBOARD, `/corp-onboarding/complete/agreement/${id}`),
      document: (id) =>
        path(ROOTS_DASHBOARD, `/corp-onboarding/complete/document/${id}`),
      upload: (id) =>
        path(ROOTS_DASHBOARD, `/corp-onboarding/complete/upload/${id}`),
    },
    view: {
      form: (npoTeamId, itemId) =>
        path(
          ROOTS_DASHBOARD,
          `/corp-onboarding/view/form/${npoTeamId}/${itemId}`
        ),
      agreement: (npoTeamId, itemId) =>
        path(
          ROOTS_DASHBOARD,
          `/corp-onboarding/view/agreement/${npoTeamId}/${itemId}`
        ),
      document: (npoTeamId, itemId) =>
        path(
          ROOTS_DASHBOARD,
          `/corp-onboarding/view/document/${npoTeamId}/${itemId}`
        ),
      upload: (npoTeamId, itemId) =>
        path(
          ROOTS_DASHBOARD,
          `/corp-onboarding/view/upload/${npoTeamId}/${itemId}`
        ),
    },
  },
  schedule: {
    root: path(ROOTS_DASHBOARD, '/my-schedule'),
    donations: path(ROOTS_DASHBOARD, '/upcoming-donations'),
  },
  admin: {
    overview: path(ROOTS_DASHBOARD, '/admin/overview'),
    users: path(ROOTS_DASHBOARD, '/admin/users'),
    viewUser: (id) => path(ROOTS_DASHBOARD, `/admin/user/${id}`),
    orgs: path(ROOTS_DASHBOARD, '/admin/organizations'),
    mergeUsers: path(ROOTS_DASHBOARD, '/admin/users/merge'),
    approvalQueue: path(ROOTS_DASHBOARD, '/admin/queue-org-new'),
    orgUpdateQueue: path(ROOTS_DASHBOARD, '/admin/queue-org-updates'),
    onboardingIntakeQueue: path(
      ROOTS_DASHBOARD,
      '/admin/queue-corporate-onboarding'
    ),
    complaintsQueue: path(ROOTS_DASHBOARD, '/admin/queue-complaints'),
    map: path(ROOTS_DASHBOARD, '/admin/map'),
    outreach: path(ROOTS_DASHBOARD, '/admin/outreach'),
    mergeOrgs: path(ROOTS_DASHBOARD, '/admin/organizations/merge'),
    duplicateOrgs: path(ROOTS_DASHBOARD, '/admin/organizations/duplicates'),
    createOrg: path(ROOTS_DASHBOARD, `/admin/organization/create`),
    viewOrg: (id) => path(ROOTS_DASHBOARD, `/admin/organization/${id}`),
    subscriptions: path(ROOTS_DASHBOARD, '/admin/subscriptions'),
    licensing: {
      overview: path(ROOTS_DASHBOARD, '/admin/licensing'),
      clients: path(ROOTS_DASHBOARD, '/admin/licensing/clients'),
      viewClient: (id) =>
        path(ROOTS_DASHBOARD, `/admin/licensing/clients/${id}`),
      clientPattern: path(ROOTS_DASHBOARD, '/admin/licensing/clients/:id'),
      map: path(ROOTS_DASHBOARD, '/admin/licensing/map'),
      schedule: path(ROOTS_DASHBOARD, '/admin/licensing/schedule'),
    },
    brands: path(ROOTS_DASHBOARD, '/admin/brands'),
    newBrand: path(ROOTS_DASHBOARD, '/admin/brands/new'),
    editBrand: (id) => path(ROOTS_DASHBOARD, `/admin/brands/${id}`),
    brandPattern: path(ROOTS_DASHBOARD, '/admin/brands/:id'),
    executiveUsers: path(ROOTS_DASHBOARD, '/executive-users'),
    viewExecutiveUsers: (id) => path(ROOTS_DASHBOARD, `/executive-users/${id}`),
    corporateAccounts: path(ROOTS_DASHBOARD, '/corporate-users'),
    viewCorporateAccount: (id) =>
      path(ROOTS_DASHBOARD, `/corporate-users/${id}`),
    imports: {
      root: path(ROOTS_DASHBOARD, '/admin/import'),
      donations: path(ROOTS_DASHBOARD, '/admin/import/donations'),
      users: path(ROOTS_DASHBOARD, '/admin/import/users'),
    },
    chats: path(ROOTS_DASHBOARD, '/admin/chats'),
    sms: path(ROOTS_DASHBOARD, '/admin/sms'),
    freshcueNotifications: path(
      ROOTS_DASHBOARD,

      '/admin/freshcue-notifications'
    ),
    freshcueWaitlist: path(ROOTS_DASHBOARD, '/admin/freshcue-waitlist'),
    deletions: {
      root: path(ROOTS_DASHBOARD, '/admin/deletions'),
      donations: path(ROOTS_DASHBOARD, '/admin/deletions/donations'),
      foodRuns: path(ROOTS_DASHBOARD, '/admin/deletions/food-runs'),
      orgs: path(ROOTS_DASHBOARD, '/admin/deletions/orgs'),
    },
    inventory: path(ROOTS_DASHBOARD, '/admin/inventory'),
    distributions: {
      root: path(ROOTS_DASHBOARD, '/admin/distributions'),
      org: (teamId) => path(ROOTS_DASHBOARD, `/admin/distributions/${teamId}`),
      orgPattern: path(ROOTS_DASHBOARD, '/admin/distributions/:teamId'),
    },
    cancellations: path(ROOTS_DASHBOARD, '/admin/cancellations'),
    einStatus: path(ROOTS_DASHBOARD, '/admin/ein-status'),
    marketplace: path(ROOTS_DASHBOARD, '/admin/marketplace'),
    marketplaceGeneral: path(ROOTS_DASHBOARD, '/admin/marketplace/general'),
    marketplaceSales: path(ROOTS_DASHBOARD, '/admin/marketplace/sales'),
    marketplaceListings: path(ROOTS_DASHBOARD, '/admin/marketplace/listings'),
    marketplaceSellers: path(ROOTS_DASHBOARD, '/admin/marketplace/sellers'),
    marketplaceSettings: path(ROOTS_DASHBOARD, '/admin/marketplace/settings'),
    marketplaceReconciliation: path(
      ROOTS_DASHBOARD,
      '/admin/marketplace/reconciliation'
    ),
    viewInventory: (id) => path(ROOTS_DASHBOARD, `/admin/inventory/${id}`),
    crm: {
      root: path(ROOTS_DASHBOARD, '/admin/crm'),
      pipeline: (id = ':id') =>
        path(ROOTS_DASHBOARD, `/admin/crm/pipeline/${id}`),
      deal: (id = ':id') => path(ROOTS_DASHBOARD, `/admin/crm/deal/${id}`),
      contacts: path(ROOTS_DASHBOARD, '/admin/crm/contacts'),
      contactDetail: (id = ':id') =>
        path(ROOTS_DASHBOARD, `/admin/crm/contact/${id}`),
      companies: path(ROOTS_DASHBOARD, '/admin/crm/companies'),
      company: (id = ':id') =>
        path(ROOTS_DASHBOARD, `/admin/crm/company/${id}`),
      summary: path(ROOTS_DASHBOARD, '/admin/crm/summary'),
      calendar: path(ROOTS_DASHBOARD, '/admin/crm/calendar'),
      auditLog: path(ROOTS_DASHBOARD, '/admin/crm/audit-log'),
      import: path(ROOTS_DASHBOARD, '/admin/crm/import'),
      settings: path(ROOTS_DASHBOARD, '/admin/crm/settings'),
      tasks: path(ROOTS_DASHBOARD, '/admin/crm/tasks'),
      task: (id = ':id') => path(ROOTS_DASHBOARD, `/admin/crm/task/${id}`),
      activities: path(ROOTS_DASHBOARD, '/admin/crm/activities'),
      leads: path(ROOTS_DASHBOARD, '/admin/crm/leads'),
      prospecting: path(ROOTS_DASHBOARD, '/admin/crm/prospecting'),
      leadDetail: (id = ':id') =>
        path(ROOTS_DASHBOARD, `/admin/crm/lead/${id}`),
    },
    adminUsers: path(ROOTS_DASHBOARD, '/admin/admin-users'),
    newsletters: {
      root: path(ROOTS_DASHBOARD, '/admin/newsletters'),
      create: path(ROOTS_DASHBOARD, '/admin/newsletters/new'),
      edit: (id = ':id') =>
        path(ROOTS_DASHBOARD, `/admin/newsletters/${id}/edit`),
      detail: (id = ':id') => path(ROOTS_DASHBOARD, `/admin/newsletters/${id}`),
      subscribers: path(ROOTS_DASHBOARD, '/admin/newsletters/subscribers'),
      groups: path(ROOTS_DASHBOARD, '/admin/newsletters/groups'),
      templates: path(ROOTS_DASHBOARD, '/admin/newsletters/templates'),
      deliverability: path(
        ROOTS_DASHBOARD,
        '/admin/newsletters/deliverability'
      ),
      automations: path(ROOTS_DASHBOARD, '/admin/newsletters/automations'),
      automation: (id = ':id') =>
        path(ROOTS_DASHBOARD, `/admin/newsletters/automations/${id}`),
      activity: path(ROOTS_DASHBOARD, '/admin/newsletters/activity'),
    },
    mobileApps: path(ROOTS_DASHBOARD, '/admin/mobile-apps'),
    kb: path(ROOTS_DASHBOARD, '/admin/kb'),
    kbArticle: (id = ':articleId') =>
      path(ROOTS_DASHBOARD, `/admin/kb/articles/${id}`),
  },
  settings: {
    account: (tab, section) =>
      path(
        ROOTS_DASHBOARD,
        `/settings/account/${tab}${section ? '#' : ''}${section || ''}`
      ),
    business: (tab, section) =>
      path(
        ROOTS_DASHBOARD,
        `/settings/business/${tab}${section ? '#' : ''}${section || ''}`
      ),
    tags: path(ROOTS_DASHBOARD, `/settings/tags`),
    documents: path(ROOTS_DASHBOARD, '/documents'),
  },
  imports: {
    user: path(ROOTS_DASHBOARD, '/admin/import-users'),
    npo: path(ROOTS_DASHBOARD, '/admin/import-npo'),
    donor: path(ROOTS_DASHBOARD, '/admin/import-donor'),
  },
  foodRun: {
    allRuns: path(ROOTS_DASHBOARD, '/all-runs'),
    myRuns: path(ROOTS_DASHBOARD, '/my-runs'),
    availableRuns: path(ROOTS_DASHBOARD, '/available-runs'),
    runHistory: path(ROOTS_DASHBOARD, '/run-history'),
    inProgress: path(ROOTS_DASHBOARD, '/food-run/in-progress'),
    toBeReassigned: path(ROOTS_DASHBOARD, '/food-run/to-be-reassigned'),
  },
  distributions: {
    root: path(ROOTS_DASHBOARD, '/distributions'),
    dashboard: path(ROOTS_DASHBOARD, '/distributions'),
    programs: path(ROOTS_DASHBOARD, '/distributions/programs'),
    program: (id) => path(ROOTS_DASHBOARD, `/distributions/programs/${id}`),
    recipients: path(ROOTS_DASHBOARD, '/distributions/recipients'),
    clients: path(ROOTS_DASHBOARD, '/distributions/recipients/clients'),
    client: (id) =>
      path(ROOTS_DASHBOARD, `/distributions/recipients/clients/${id}`),
    households: path(ROOTS_DASHBOARD, '/distributions/recipients/households'),
    household: (id) =>
      path(ROOTS_DASHBOARD, `/distributions/recipients/households/${id}`),
    members: path(ROOTS_DASHBOARD, '/distributions/recipients/members'),
    requests: path(ROOTS_DASHBOARD, '/distributions/routes/requests'),
    settings: path(ROOTS_DASHBOARD, '/distributions/settings'),
    schedules: path(ROOTS_DASHBOARD, '/distributions/routes/schedules'),
    standingRoutes: path(ROOTS_DASHBOARD, '/distributions/routes/standing'),
    standingRoute: (id) =>
      path(ROOTS_DASHBOARD, `/distributions/routes/standing?id=${id}`),
    pickupSites: path(ROOTS_DASHBOARD, '/distributions/settings/pickup-sites'),
    items: path(ROOTS_DASHBOARD, '/distributions/settings/items'),
    holidays: path(ROOTS_DASHBOARD, '/distributions/settings/holidays'),
    addressAudit: path(
      ROOTS_DASHBOARD,
      '/distributions/settings/address-audit'
    ),
    runs: path(ROOTS_DASHBOARD, '/distributions/routes'),
    run: (id) => path(ROOTS_DASHBOARD, `/distributions/routes/${id}`),
    deliveries: path(ROOTS_DASHBOARD, '/distributions/routes/deliveries'),
    prep: path(ROOTS_DASHBOARD, '/distributions/routes/prep'),
    driverBoard: path(ROOTS_DASHBOARD, '/distributions/routes/available'),
    availableRoutes: path(ROOTS_DASHBOARD, '/distributions/routes/available'),
    myRoutes: path(ROOTS_DASHBOARD, '/distributions/routes/my-routes'),
    runBuilder: path(ROOTS_DASHBOARD, '/distributions/routes/build'),
    reports: path(ROOTS_DASHBOARD, '/reports/distributions'),
    legacyPickupSites: path(ROOTS_DASHBOARD, '/distributions/pickup-sites'),
    legacyHouseholds: path(ROOTS_DASHBOARD, '/distributions/households'),
    legacyHousehold: (id) =>
      path(ROOTS_DASHBOARD, `/distributions/households/${id}`),
    legacyMembers: path(ROOTS_DASHBOARD, '/distributions/members'),
    legacyRecipientRequests: path(
      ROOTS_DASHBOARD,
      '/distributions/recipients/requests'
    ),
    legacyItems: path(ROOTS_DASHBOARD, '/distributions/items'),
    legacySchedules: path(ROOTS_DASHBOARD, '/distributions/schedules'),
    legacySettingsSchedules: path(
      ROOTS_DASHBOARD,
      '/distributions/settings/schedules'
    ),
    legacyRuns: path(ROOTS_DASHBOARD, '/distributions/runs'),
    legacyRun: (id) => path(ROOTS_DASHBOARD, `/distributions/runs/${id}`),
    legacyServiceDayRun: (id) =>
      path(ROOTS_DASHBOARD, `/distributions/routes/service-days/${id}`),
    legacyDriverBoard: path(ROOTS_DASHBOARD, '/distributions/driver-board'),
    legacyAvailableRoutes: path(
      ROOTS_DASHBOARD,
      '/distributions/available-routes'
    ),
    legacyMyRoutes: path(ROOTS_DASHBOARD, '/distributions/my-routes'),
    legacyRunBuilder: path(ROOTS_DASHBOARD, '/distributions/run-builder'),
    legacyRequests: path(ROOTS_DASHBOARD, '/distributions/requests'),
    legacyReports: path(ROOTS_DASHBOARD, '/distributions/reports'),
  },
  executive: {
    orgSettings: path(ROOTS_DASHBOARD, '/executive/org-settings'),
    home: path(ROOTS_DASHBOARD, '/executive/home'),
    onboardingRequests: path(ROOTS_DASHBOARD, '/executive/onboarding-requests'),
    orgs: path(ROOTS_DASHBOARD, '/executive/organizations'),
    viewOrg: (id) => path(ROOTS_DASHBOARD, `/executive/organizations/${id}`),
    donations: {
      all: path(ROOTS_DASHBOARD, '/executive/donations'),
      incoming: path(ROOTS_DASHBOARD, '/executive/donations/incoming'),
      outgoing: path(ROOTS_DASHBOARD, '/executive/donations/outgoing'),
      internal: path(ROOTS_DASHBOARD, '/executive/donations/internal'),
    },
    geozones: path(ROOTS_DASHBOARD, '/executive/geozones'),
    createOrg: path(ROOTS_DASHBOARD, '/executive/create-organization'),
    penalties: {
      log: path(ROOTS_DASHBOARD, '/executive/penalties/log'),
      recommended: path(ROOTS_DASHBOARD, '/executive/penalties/recommended'),
      history: path(ROOTS_DASHBOARD, '/executive/penalties/history'),
    },
    inspections: {
      all: path(ROOTS_DASHBOARD, '/executive/inspections'),
      mine: path(ROOTS_DASHBOARD, '/executive/my-inspections'),
      incomplete: path(ROOTS_DASHBOARD, '/executive/incomplete-inspections'),
      view: (id) => path(ROOTS_DASHBOARD, `/executive/inspections/${id}`),
      fro: path(ROOTS_DASHBOARD, '/executive/inspections/fro'),
      efg: path(ROOTS_DASHBOARD, '/executive/inspections/efg'),
      reports: {
        _: path(ROOTS_DASHBOARD, '/executive/report'),
        fro: path(ROOTS_DASHBOARD, '/executive/report/fro'),
        efg: path(ROOTS_DASHBOARD, '/executive/report/efg'),
      },
    },
    complaints: {
      all: path(ROOTS_DASHBOARD, '/executive/complaints'),
      mine: path(ROOTS_DASHBOARD, '/executive/my-complaints'),
      incomplete: path(ROOTS_DASHBOARD, '/executive/incomplete-complaints'),
      view: (id) => path(ROOTS_DASHBOARD, `/executive/complaints/${id}`),
      form: path(ROOTS_DASHBOARD, '/executive/complaints/form'),
      report: path(ROOTS_DASHBOARD, '/executive/report/complaints'),
    },
    nov: {
      recommendedReport: path(
        ROOTS_DASHBOARD,
        '/executive/reports/nov-recommended'
      ),
      issuedReport: path(ROOTS_DASHBOARD, '/executive/reports/nov-issued'),
    },
    contactSummary: path(ROOTS_DASHBOARD, '/executive/contact-summary'),
    complianceSummary: path(ROOTS_DASHBOARD, '/executive/compliance-summary'),
    contactLog: path(ROOTS_DASHBOARD, '/executive/contact-log'),
    activityLog: path(ROOTS_DASHBOARD, '/executive/activity-log'),
    scheduling: {
      appointments: path(ROOTS_DASHBOARD, '/executive/scheduling/appointments'),
      appointmentNew: path(
        ROOTS_DASHBOARD,
        '/executive/scheduling/appointments/new'
      ),
      appointmentView: (id) =>
        path(ROOTS_DASHBOARD, `/executive/scheduling/appointments/${id}`),
      appointmentEdit: (id) =>
        path(ROOTS_DASHBOARD, `/executive/scheduling/appointments/${id}/edit`),
      calendar: path(ROOTS_DASHBOARD, '/executive/scheduling/calendar'),
    },
  },
  corporate: {
    orgSettings: path(ROOTS_DASHBOARD, '/corporate/settings'),
    home: path(ROOTS_DASHBOARD, '/corporate/home'),
    teams: path(ROOTS_DASHBOARD, '/corporate/teams'),
    recipients: path(ROOTS_DASHBOARD, '/corporate/recipients'),
    viewTeam: (id) => path(ROOTS_DASHBOARD, `/corporate/team/${id}`),
    schedule: path(ROOTS_DASHBOARD, '/corporate/donations/schedule'),
    donations: path(ROOTS_DASHBOARD, '/corporate/donations'),
    viewDonation: (id) => path(ROOTS_DASHBOARD, `/corporate/donations/${id}`),
    report: path(ROOTS_DASHBOARD, '/corporate/report'),
    taxReceipts: path(ROOTS_DASHBOARD, '/corporate/tax-receipts'),
    nonDonatingLocationsReport: path(
      ROOTS_DASHBOARD,
      '/corporate/non-donating-locations-report'
    ),
    donorTeamOnboardingReport: path(
      ROOTS_DASHBOARD,
      '/corporate/donor-team-onboarding-report'
    ),
    wasteReport: path(ROOTS_DASHBOARD, '/corporate/waste-report'),
    cancellationsReport: path(
      ROOTS_DASHBOARD,
      '/corporate/cancellations-report'
    ),
    onboarding: {
      root: path(ROOTS_DASHBOARD, '/corporate/onboarding'),
      requests: path(ROOTS_DASHBOARD, '/corporate/onboarding/requests'),
      intakeQueue: path(ROOTS_DASHBOARD, '/corporate/onboarding/intake'),
      request: (id, teamId) =>
        path(ROOTS_DASHBOARD, `/corporate/onboarding/requests/${teamId}/${id}`),
      complianceProfile: {
        root: path(
          ROOTS_DASHBOARD,
          '/corporate/onboarding/compliance-profiles'
        ),
        create: path(
          ROOTS_DASHBOARD,
          '/corporate/onboarding/compliance-profile/new'
        ),
        view: (id) =>
          path(
            ROOTS_DASHBOARD,
            `/corporate/onboarding/compliance-profile/details/${id}`
          ),
        edit: (id) =>
          path(
            ROOTS_DASHBOARD,
            `/corporate/onboarding/compliance-profile/edit/${id}`
          ),
      },
      create: (profileId) => ({
        form: path(
          ROOTS_DASHBOARD,
          `/corporate/onboarding/create/form/${profileId}`
        ),
        agreement: path(
          ROOTS_DASHBOARD,
          `/corporate/onboarding/create/agreement/${profileId}`
        ),
        document: path(
          ROOTS_DASHBOARD,
          `/corporate/onboarding/create/document/${profileId}`
        ),
        upload: path(
          ROOTS_DASHBOARD,
          `/corporate/onboarding/create/upload/${profileId}`
        ),
      }),
      edit: {
        form: (id) =>
          path(ROOTS_DASHBOARD, `/corporate/onboarding/edit/form/${id}`),
        agreement: (id) =>
          path(ROOTS_DASHBOARD, `/corporate/onboarding/edit/agreement/${id}`),
        document: (id) =>
          path(ROOTS_DASHBOARD, `/corporate/onboarding/edit/document/${id}`),
        upload: (id) =>
          path(ROOTS_DASHBOARD, `/corporate/onboarding/edit/upload/${id}`),
      },
      submissions: {
        form: (id) =>
          path(ROOTS_DASHBOARD, `/corporate/onboarding/submissions/form/${id}`),
      },
      progress: {
        form: (id, teamId) =>
          path(
            ROOTS_DASHBOARD,
            `/corporate/onboarding/progress/form/${id}/${teamId}`
          ),
        agreement: (id, teamId) =>
          path(
            ROOTS_DASHBOARD,
            `/corporate/onboarding/progress/agreement/${id}/${teamId}`
          ),
        document: (id, teamId) =>
          path(
            ROOTS_DASHBOARD,
            `/corporate/onboarding/progress/document/${id}/${teamId}`
          ),
        upload: (id, teamId) =>
          path(
            ROOTS_DASHBOARD,
            `/corporate/onboarding/progress/upload/${id}/${teamId}`
          ),
      },
    },
  },
  inventory: path(ROOTS_DASHBOARD, '/inventory'),
  wasteTracking: path(ROOTS_DASHBOARD, '/waste-tracking'),
  freshcue: {
    root: path(ROOTS_DASHBOARD, '/freshcue'),
    manageMembers: path(ROOTS_DASHBOARD, '/freshcue/manage-members'),
    donors: path(ROOTS_DASHBOARD, '/freshcue/donors'),
    donorStats: path(ROOTS_DASHBOARD, '/freshcue/donor-stats'),
    allPosts: path(ROOTS_DASHBOARD, '/freshcue/all-posts'),
    businessPosts: path(ROOTS_DASHBOARD, '/freshcue/posts'),
    businessReservations: path(ROOTS_DASHBOARD, '/freshcue/reservations'),
    postDetails: (postId = ':postId') =>
      path(ROOTS_DASHBOARD, `/freshcue/posts/${postId}`),
  },
  taxReceipts: path(ROOTS_DASHBOARD, '/tax-receipts'),
  foodMoverTaxReceipts: path(ROOTS_DASHBOARD, '/food-mover/tax-receipts'),
  taxReceiptsRedirect: path(ROOTS_DASHBOARD, '/go-to-tax-receipts'),
};
